import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { history } from "../..";
import { RootStore } from "./rootStore";
import { CaboloErrorEnum, CaboloStatusEnum, ICaboloMeetingInfo, IcaboloRecodingFormValues, ICaboloRecordingForm, ICaboloRecordingSettings, IRecordingMeetingPageDto, LanguagePair, RecStatus } from "../models/cabolo";
import { toast } from "react-toastify";
import { getToastTranslation } from "../helpers/translationHelper";
export default class caboloStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

loadingRecordingMeetingCaboloPage: boolean = false;
recordingMeetingCaboloPageDto: IRecordingMeetingPageDto | null= null;

loadingCaboloStatus = false;

CaboloStatus: string = "";

caboloMeetigInfo: ICaboloMeetingInfo | null= null;

caboloRecodingSettings: ICaboloRecordingSettings | null = null;

recordingCaboloStatus: RecStatus | null = null;



get IsRecordingCurrentMeeting() {
  const { attendingMeeting } = this.rootStore.playerStore;
  if(attendingMeeting && this.recordingCaboloStatus){
  return attendingMeeting.id== this.recordingCaboloStatus.meetingId ;
  }
}

// get isRecordingStatusDefault() {
//   const status = this.recordingCaboloStatus;
//  const { attendingMeeting } = this.rootStore.playerStore;
//   return (
//     status != null &&
//     status.audioLength === 0 &&
//     status.recordingId === 0 &&
//     status.sttTranscriptionlenght === 0 &&
//     status.isRecordingMeeting === false &&
//     status.meetingId === attendingMeeting?.id
//   );
// }

catchErrorCabolo = (error: any) => {
  const caboloError = error?.data?.errors?.code;
  const isCaboloError = Object.values(CaboloErrorEnum).includes(caboloError);

  if (isCaboloError) {
    toast.error(getToastTranslation(caboloError));
  }else{
    // Gestione degli errori generici
    toast.error(getToastTranslation("error"));
  }
};

// RECORDING MEETING CABOLO
  loadTranscriptionCabolo = async (meetingId: number ) => {
    try {
      this.loadingRecordingMeetingCaboloPage= true
      const dto = await agent.Cabolo.getRecordingMeetingCabolo(meetingId);
    
      runInAction(() => {
        this.recordingMeetingCaboloPageDto = dto;
        this.loadingRecordingMeetingCaboloPage= false;
      });
      return dto;
    } catch (error) {
      console.log(error);
    }
  };

  resetRecordingMeetingCaboloPage = () => {
    this.recordingMeetingCaboloPageDto = null;
  }

  deleteRecordingMeetingCabolo = async (  
    Id: number) => {
    try {
      await agent.Cabolo.deleteRecordingMeetingCabolo(Id);
      toast.success(getToastTranslation("delete_recording"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("error"));
    }
  };
  
   // STATUS CABOLO

// getCaboloStatus = async (caboloId: number) => {
//     try {
//          this.loadingCaboloStatus = true;
//         const dto = await agent.Cabolo.getCaboloStatus(caboloId);
//        runInAction(() => {
         
//           this.CaboloStatus =  dto.status;
//           this.loadingCaboloStatus = false;
      
//         });
//         return dto;
       
//       } catch (error) {  
//         runInAction(() => {
//             this.catchErrorCabolo(error);
//             this.loadingCaboloStatus = false;
//         });
//         console.log(error);
//       }

// }
 getCaboloStatus= async(caboloId: number, isFirstCall = false) => {
  if (isFirstCall) {
    this.loadingCaboloStatus = true; // solo nella prima chiamata
  }

  try {
    const dto = await  agent.Cabolo.getCaboloStatus(caboloId);
    runInAction(() => {
     this.CaboloStatus = dto.status;
   
      if (isFirstCall) this.loadingCaboloStatus = false;
    });
    return dto;
  } catch (error) {
    runInAction(() => {
      this.CaboloStatus = CaboloStatusEnum.STATE_ERROR_CONNECTION;
      if (isFirstCall) this.loadingCaboloStatus = false;
    });
    console.error(error);
  }
}


 resetCaboloStatus = () => {
 this.CaboloStatus = "";
    }

    
    // GET INFO CABOLO MEETING
    getCaboloInfoMeeting = async (meeetinId: number) => {
      try {
          
          const dto = await agent.Cabolo.getCaboloMeetingInfo(meeetinId);
         runInAction(() => {
           this.caboloMeetigInfo = dto;
          
          
          });
          return dto;
         
        } catch (error) {  
          runInAction(() => {
              this.catchErrorCabolo(error);
             
          });
          console.log(error);
        }
  
  }

  // RECUPERO IL SETTAGGIO  DEL CABOLO SETTINGS
getSettingCabolo = async (caboloId: number, meetingId: number) => {
  var deviceId=0;
  var transcriptionModelId=0;
  var languagePairSelected :string[]=[];
  var allLanguagePairs:  LanguagePair[] = [];
   var devices = await agent.Cabolo.getAudioDevices(caboloId);
   var devicesDefault= devices.find((d) => d.isDefault);
   if(devicesDefault)
    deviceId = devicesDefault.id;
   var models = await agent.Cabolo.getTranscriptionModels(caboloId);
   var modelsDefault = models.find((m) => m.isDefault);
    if(modelsDefault)
      transcriptionModelId = modelsDefault.id;
   var languagePairs = await agent.Cabolo.getlanguagePairs(caboloId);
   allLanguagePairs = languagePairs;
   var languagePairsDefault = languagePairs.filter((l) => l.isDefault).map((l) => l.targetLanguageId);
    if(languagePairsDefault)
      languagePairSelected = languagePairsDefault;
  
    
    var  settings: ICaboloRecordingSettings = {
      meetingId: meetingId,
      caboloId: caboloId,
      audioDeviceId: deviceId,
      transcriptionModelId: transcriptionModelId,
      languagePairSelected: languagePairSelected,
      audioDevices: devices,
      transcriptionModels: models,
      languagePairs: allLanguagePairs
    }
    this.caboloRecodingSettings = settings;
    return settings;
}

 resetSettingCabolo = () => {
  this.caboloRecodingSettings = null;
 }

// Start recording 

startRecordingCabolo = async (form: ICaboloRecordingForm) => {
  try {
     await agent.Cabolo.startRegistration(form);
    runInAction(() => {
      this.CaboloStatus = CaboloStatusEnum.STATE_PLAYING;
      toast.success(getToastTranslation("start_recording"));
    });
  } catch (error) {
    console.log(error);
    this.catchErrorCabolo(error);
  }
}

stopRecordingCabolo = async () => {
 try {
  const { attendingMeeting } = this.rootStore.playerStore;
  if(this.caboloMeetigInfo && attendingMeeting){
  var form= new IcaboloRecodingFormValues();
  form.caboloId = this.caboloMeetigInfo.caboloId;
  form.meetingId = attendingMeeting.id;
    await agent.Cabolo.stopRecording(form);
    runInAction(() => {
      this.CaboloStatus = CaboloStatusEnum.STATE_READY;
      toast.success(getToastTranslation("stop_recording"));
  });
  }
}catch (error) {
  console.log(error);
  this.catchErrorCabolo(error);
}
}

pauseRecordingCabolo = async () => {
  try {
   const { attendingMeeting } = this.rootStore.playerStore;
   if(this.caboloMeetigInfo && attendingMeeting){
   var form= new IcaboloRecodingFormValues();
   form.caboloId = this.caboloMeetigInfo.caboloId;
   form.meetingId = attendingMeeting.id;
     await agent.Cabolo.pauseRecording(form);
     runInAction(() => {
      this.CaboloStatus = CaboloStatusEnum.STATE_PAUSED;
       toast.success(getToastTranslation("pause_recording"));
   });
   }
 }catch (error) {
   console.log(error);
   this.catchErrorCabolo(error);
 }
 }

 resumeRecordingCabolo = async () => {
  try {
   const { attendingMeeting } = this.rootStore.playerStore;
   if(this.caboloMeetigInfo && attendingMeeting){
   var form= new IcaboloRecodingFormValues();
   form.caboloId = this.caboloMeetigInfo.caboloId;
   form.meetingId = attendingMeeting.id;
     await agent.Cabolo.resumeRecording(form);
     runInAction(() => {
       toast.success(getToastTranslation("resume_recording"));
   });
   }
 }catch (error) {
   console.log(error);
   this.catchErrorCabolo(error);
 }
 }

 startInterruptedRecordingCabolo = async () => {
  try {
   const { attendingMeeting } = this.rootStore.playerStore;
   if(this.caboloMeetigInfo && attendingMeeting){
   var form= new IcaboloRecodingFormValues();
   form.caboloId = this.caboloMeetigInfo.caboloId;
   form.meetingId = attendingMeeting.id;
     await agent.Cabolo.startInterruptedRecording(form);
     runInAction(() => {
       this.CaboloStatus = CaboloStatusEnum.STATE_CHANGE_READY_TO_PLAY;
       toast.success(getToastTranslation("resume_recording"));
   });
   }
 }catch (error) {
   console.log(error);
   this.catchErrorCabolo(error);
 }
 }
 
getRecStatus = async (caboloId: number, status: string) => {
  try {
    const { attendingMeeting } = this.rootStore.playerStore;
        if(
           status !== CaboloStatusEnum.STATE_READY
           && status!== CaboloStatusEnum.STATE_ERROR_CONNECTION
           && status !== CaboloStatusEnum.STATE_LOADING
           && status !== CaboloStatusEnum.STATE_LICENSE_EXPIRED
          ){
            const dto = await agent.Cabolo.getRecStatusCabolo(caboloId);
            runInAction(() => {
              this.recordingCaboloStatus = dto;
            });
            return dto;
          }else{
     // Reset ai valori di default
      runInAction(() => {
        this.recordingCaboloStatus = {
          audioLength: 0,
          recordingId: 0,
          sttTranscriptionlenght: 0,
          isRecordingMeeting: false,
           meetingId: attendingMeeting?.id || 0
         
        };
      });
          }
  
  } catch (error) {
    console.log(error);
    this.catchErrorCabolo(error);
  }
}


}




